/** @module AQL/FIStateHeadingRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/EnumAction"
], function(declare,EnumAction) {
	return declare(EnumAction, {
		/**
		 * @override
		 * Reopen action needs to be enabled when node is frozen
		 */
		disableAction: function(ctx) {
			return false;
		}
	});
});